import { Match } from "effect";
import { INTERNAL_HTTP_MESSAGE } from "@workerstation/shared/errors/http";
import type { ExecutionFailure } from "./model.ts";
export const executionFailureMessage = (failure: ExecutionFailure): string => Match.value(failure).pipe(
  Match.tag("ResourceRequestError", value => value.message),
  Match.tag("HostedTestHttpError", value => value.message),
  Match.tag("ResourceStorageError", () => INTERNAL_HTTP_MESSAGE),
  Match.exhaustive
);
